import React from 'react';
import styled from 'styled-components';

export type IconType = keyof typeof leftCloseEyeShapeMap;
// export const iconTypes: IconType[] = Object.keys(icons) as IconType[];

export const leftCloseEyeShapeMap = {
  1: 'M43 76C43 76 41 77.5 36 77.5C31 77.5 26 72.5 26 72.5',
  2: 'M56.6561 72.9567C56.6561 72.9567 58.0153 75.0549 62.7078 76.7812C67.4004 78.5075 73.8192 75.5411 73.8192 75.5411',
  3: 'M56.6703 74.2317C56.6703 74.2317 60.5 74.2374 66 74.2374C71.5 74.2374 74.0268 74.2374 74.0268 74.2374',
  4: 'M56.6703 74.2317C56.6703 74.2317 59.1031 73.9901 64 75C68.8969 76.0099 74.0268 74.2374 74.0268 74.2374',
};

export const leftCloseEyeidShapeMap = {
  1: 'M43 72C39.8333 73 32.5 73.9 28.5 69.5',
  2: 'M58.0373 69.2026C60.664 71.2344 67.2357 74.6109 72.5088 71.8625',
  3: 'M57.4782 70.3141C61.4999 70.3141 65.8157 70.3141 72 70.3141',
  4: 'M57.4782 70.3141C61.5 70.3141 66.5 72.5 72.1843 70.7943',
};

export const rightCloseEyeShapeMap = {
  1: 'M57 76C57 76 59 77.5 64 77.5C69 77.5 74 72.5 74 72.5',
  2: 'M43.3552 73.1992C43.3552 73.1992 41.9361 75.2573 37.1956 76.8474C32.4552 78.4375 26.1247 75.2871 26.1247 75.2871',
  3: 'M43.3566 74.2317C43.3566 74.2317 41.0269 74.2374 35.5 74.2374C29.9731 74.2374 26 74.2374 26 74.2374',
  4: 'M43.3566 74.2317C43.3566 74.2317 40.9238 73.9901 36.0269 75C31.1299 76.0099 26 74.2374 26 74.2374',
};

export const rightCloseEyelidShapeMap = {
  1: 'M57 72C60.1667 73 67.5 73.9 71.5 69.5',
  2: 'M42.0834 69.4068C39.3991 71.362 32.7327 74.5473 27.5411 71.6478',
  3: 'M42.5487 70.3141C38.5269 70.3141 33.6575 70.3141 27.5 70.3141',
  4: 'M42.5486 70.3141C38.5269 70.3141 33.5269 72.5 27.8425 70.7943',
};

export interface Props {
  icon: IconType | string;
  strokeWidth?: number;
  color?: string;
  eyelidColor?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function CloseEyes({ icon, strokeWidth, color, eyelidColor }: Props) {
  return (
    <>
      {/* left */}
      <g className="close-eye">
        <path
          d={leftCloseEyeShapeMap[icon]}
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={leftCloseEyeidShapeMap[icon]}
          stroke={eyelidColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      {/* right */}
      <g className="close-eye">
        <path
          d={rightCloseEyeShapeMap[icon]}
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d={rightCloseEyelidShapeMap[icon]}
          stroke={eyelidColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  );
}

export default CloseEyes;
